import {
  ACTIVATE_FEATURE_COMPLETED,
  ACTIVATE_FEATURE_FAILED,
  ACTIVATE_FEATURE_REQUESTED
} from '../actions/ActivateFeature';

const initialState = {
  loading: true,
  data: {},
};

const activateFeature = (state = initialState, action) => {
  switch (action.type) {
    case ACTIVATE_FEATURE_REQUESTED:
      return initialState;
    case ACTIVATE_FEATURE_COMPLETED:
      return {
        loading: false,
      };
    case ACTIVATE_FEATURE_FAILED:
      return Object.assign({}, initialState, {
        loading: false,
      });
    default:
      return state;
  }
};

export default activateFeature;
